import { render, staticRenderFns } from "./key-unit.vue?vue&type=template&id=1b5fbe45&scoped=true"
import script from "./key-unit.vue?vue&type=script&lang=js"
export * from "./key-unit.vue?vue&type=script&lang=js"
import style0 from "./key-unit.vue?vue&type=style&index=0&id=1b5fbe45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5fbe45",
  null
  
)

export default component.exports